import { render, staticRenderFns } from "./LuExciseTransactionType.vue?vue&type=template&id=605f81f9&"
import script from "./LuExciseTransactionType.vue?vue&type=script&lang=js&"
export * from "./LuExciseTransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports